import { Alert, Button, Center, Group, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { logout } from "~/utils/Helper";

import PublicPageContainer from "./PublicPageContainer";

type AuthErrorPanelProps = {
  message: string;
  onRetry?: () => void;
};

const AuthErrorPanel = ({ message, onRetry }: AuthErrorPanelProps) => {
  const { t } = useTranslation();

  return (
    <PublicPageContainer>
      <Center mih={400}>
        <Stack align="center" gap="md" maw={520}>
          <Alert color="red" title={t("authErrors.title")}>
            <Text>{message}</Text>
          </Alert>
          <Group>
            {onRetry && (
              <Button variant="filled" onClick={onRetry}>
                {t("authErrors.retry")}
              </Button>
            )}
            <Button variant="default" onClick={logout}>
              {t("authErrors.logOut")}
            </Button>
          </Group>
        </Stack>
      </Center>
    </PublicPageContainer>
  );
};

export default AuthErrorPanel;
